import React, { useState, useEffect } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Title } from 'react-admin';


import App from '../../../../app.js';

import {ProfileShow} from "../../components/profile/profile.js";

export default () => {

	const theapp = App.getAppObject();

	const loading_str = theapp.t('loading');

	const [username, setUserName] = useState(loading_str);
	const [useremail, setUserEmail] = useState(loading_str);
	const [useruuid, setUserUUID] = useState(loading_str);

	useEffect(() => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		mvcmydashboard.getCurrentSession()
		.then(sessionuuid => {
			return mvcmydashboard.getSessionUser(sessionuuid);
		})
		.then(user => {
			setUserName(user.name );
			setUserEmail(user.email);
			setUserUUID(user.uuid);
	
		})
		.catch(err => {});

		return () => {
		};
	}, []);

	return (
		<Card>
			<Title title="Profile" />
			<CardContent>
				<ProfileShow id={(useruuid ? useruuid : 'user-profile')} resource="profile" basePath="/profile"/>

{/* 			<div>

				<div>This is the account page</div>

				<h4>User Account</h4>

				<table>

					<tbody>
					<tr>
						<td>Field</td>
						<td>Value</td>
					</tr>

					<tr>
						<td>user name</td>
						<td>{username}</td>
					</tr>

					<tr>
						<td>user email</td>
						<td>{useremail}</td>
					</tr>

					<tr>
						<td>user uuid</td>
						<td>{useruuid}</td>
					</tr>

					</tbody>
				</table>
			</div> */}
			</CardContent>
		</Card>
	);
};